module.exports = __webpack_public_path__ + "static/media/2-SegurançaeRastreabilidade.38016df6.jpg";